import React from 'react';

export const LoadingBall = () => {
    return (
        <div className="d-flex justify-content-center m-auto align-items-center">
        <div className="spinner-grow text-primary" role="status">
            <span className="sr-only">Loading...</span>
        </div>
    </div>
    );
};